const reducer = (state: WtrState, action: { error: unknown }) => ({
  ...state,
  branches: [],
  error: action.error,
  loading: false,
});

export default reducer;
